<script>
import Endpoints from '../../components/common/Endpoints';
import Common from '../../components/common/Common';
import Request from '../../components/common/Request';
import { mapActions } from 'vuex';

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN';
    if (geo.geometry.lat){
        addressObj.lat = geo.geometry.lat;
    }else return null;
    if (geo.geometry.lng){
        addressObj.lng = geo.geometry.lng;
    }else return null;

    return addressObj;
}

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        setTimeout(async function(){
         $('#spinner').modal('toggle');
        let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
        if (response && response.status==200){
            console.log(response.result);
            payload.data = response.result.companyUser.company;
            payload.data.address.state = payload.data.address.state.toUpperCase();

            payload.data.fantasyName = Common.camelize(payload.data.fantasyName);
            payload.data.socialName = Common.camelize(payload.data.socialName);
            payload.data.address.address =  Common.camelize(payload.data.address.address);
            payload.data.address.city =  Common.camelize(payload.data.address.city);
            payload.data.address.neighborhood =  Common.camelize(payload.data.address.neighborhood);
            if(payload.data.address.complement)
            {
                 payload.data.address.complement =  Common.camelize(payload.data.address.complement);
            }
        } 
        $('#spinner').modal('toggle');
        }, 100);

    },

    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data,  `${Endpoints.companies.company}${this.data.document}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.flashMessage.success(
                        this.configMessage(this.$t('string.msg.companyRegistration.register.title.success'), this.$t('string.msg.companyRegistration.register.message.success'),'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.companyRegistration.register.message.success')),
                            destroyed: this.clearText()
                        })
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
       loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.data.address, `${Endpoints.addresses.geolocation}`,
                    (geoResponse)=>{//SUCCESS CALLBACK
                        if (geoResponse.results.length==0){
                            return callbackError(this.$t('string.company.register.address.invalid'));
                        }else if (geoResponse.results.length==1){
                            let geo = geoResponse.results[0];
                            let addressObj = instanceateAddress(state.data.address, geoResponse.results[0]);
                            console.log('geoResponse.results');
                            console.log(addressObj);
                            if (addressObj){
                                return callbackSuccess(state.data);
                            }else {
                                return callbackError(state.$t('string.company.register.address.invalid'));
                            }
                        }else if (geoResponse.results.length>1){
                            state.addresses = geoResponse.results;
                            $('#modalListAddress').modal('toggle');
                        } 
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else if (res.data.messageId === 'response.already.exists'){
                                this.messageToast = this.$t('response.user.already.exists');
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        
                    });        
        },
        selectAddress: function(index){
            let addressObj = instanceateAddress(this.data.address, this.addresses[index]);
            
            if (addressObj){
                addressObj.ibge = this.data.address.ibge;
                addressObj.gia = this.data.address.gia;
                addressObj.complement = this.data.complement;
                this.data.address = addressObj;
                $('#modalListAddress').modal('toggle');
                this.save(this.data);
            }else {
                this.errors = [];
                this.errors.push(this.$t('string.company.register.address.invalid'));
                 $('#modalListAddress').modal('toggle');
            }
        },
        loadInfosByCEP: function(){
            let state = this;
            if (this.data.address.cep && this.data.address.cep.length == 9){
                $('#spinner').modal('toggle');
                Request.do(this, 'GET', {}, {}, `${Endpoints.cep.find}${this.data.address.cep}/json`,
                    (response)=>{//SUCCESS CALLBACK
                        if (response){
                            state.data.address.address = response.logradouro;
                            state.data.address.neighborhood = response.bairro;
                            state.data.address.city = response.localidade;
                            state.data.address.state = response.uf;
                            state.data.address.ibge = response.ibge;
                            state.data.address.gia = response.gia;
                        }
                        
                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        console.log(JSON.stringify(error));
                });
            }
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.fantasyName) {
                this.errors.push(this.$t('response.user.register.fantasyName.required'));
            }
            if (!this.data.socialName) {
                this.errors.push(this.$t('response.user.register.socialName.required'));
            }
            if (!this.data.document) {
                this.errors.push(this.$t('response.user.register.document.required'));
            }
            if (this.data.typeService == -1) {
                this.errors.push(this.$t('response.user.register.typeService.required'));
            }
            if (this.data.isBranch && !this.data.mainCompany) {
                this.errors.push(this.$t('response.user.register.document.maincompany'));
            }
            if (!this.data.address.cep) {
                this.errors.push(this.$t('response.address.register.cep.required'));
            }
            if (this.data.address.state == -1) {
                this.errors.push(this.$t('response.address.register.city.state.required'));
            }
            if (!this.data.address.city) {
                this.errors.push(this.$t('response.address.register.city.required'));
            }
            if (!this.data.address.neighborhood) {
                this.errors.push(this.$t('response.address.register.neighborhood.required'));
            }
            if (!this.data.address.address) {
                this.errors.push(this.$t('response.address.register.address.required'));
            }
            if (!this.data.address.number) {
                this.errors.push(this.$t('response.address.register.number.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.loadGeolocation(
                    (newData)=>{
                        this.save(newData);
                    },
                    (error)=>{
                        this.errors.push(error);
                    });
            }
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
    }
}
</script>
